// src/services/api.js
import axios from "axios";
import { getToken } from "./auth";
let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
if (window.location.protocol === "https:" && apiUrl.startsWith("http://") && !apiUrl.includes("localhost")) {
  apiUrl = apiUrl.replace("http://", "https://");
}

const api = axios.create({
  baseURL: window.Capacitor 
    ? "http://10.0.2.2:8000" 
    : apiUrl,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const activeTenantId = localStorage.getItem("active_tenant_id");
  if (activeTenantId) {
    config.headers["X-Tenant-ID"] = activeTenantId;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      import("./auth").then(({ logout }) => {
        logout();
        window.location.href = "/login";
      });
    }
    return Promise.reject(error);
  }
);

export default api;